import { useEffect, useRef, useState } from "react";
import video from "../../../Assets/Images/video.mp4";

export default function MinemoVideoBanner() {
  const [playing, setPlaying] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setPlaying(true);
        }
      },
      { threshold: 0.5 }, // 50% visible triggers play
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className="relative w-full overflow-hidden group"
      style={{
        aspectRatio: "16/6",
        minHeight: "320px",
        maxHeight: "620px",
        background: "#1a1008",
      }}
    >
      {!playing ? (
        <>
          {/* Thumbnail */}
          <img
            src="/images/mining-video-thumb.jpg"
            alt="Mining operations video"
            className="w-full h-full object-cover"
          />

          {/* Overlay */}
          <div className="absolute inset-0 bg-black/30" />
        </>
      ) : (
        <video
          className="absolute inset-0 w-full h-full object-cover"
          src={video}
          autoPlay
          muted // 🔥 IMPORTANT (autoplay won't work without this in most browsers)
          controls
        />
      )}
    </div>
  );
}
